import { LOUNGE_PER_SEGMENT } from '../products';
import { createPickAndChooseProduct } from '../common/pick-and-choose';
import { loungePerSegmentConfig } from './config';
import { getGraphQlSelection } from './utils/getGraphQlSelection';
import LoungePerSegment from './components/LoungePerSegment';
const {
  id,
  name: formSection
} = LOUNGE_PER_SEGMENT;
const product = createPickAndChooseProduct(loungePerSegmentConfig);
export const loungePerSegment = {
  formSection,
  getSelected: product.getSelected,
  getPrice: product.getPrice,
  getAvailability: product.getAvailability,
  getGraphQlSelection: getGraphQlSelection(String(id), formSection),
  ...LOUNGE_PER_SEGMENT
};
export default LoungePerSegment;
//# sourceMappingURL=index.js.map